<template>
  <div class="chat-welcome-content">
    <div class="chat-welcome">
      <div class="chat-logo">
        <Icon name="lucide:sparkles" />
      </div>
      <h3>Welcome to AI Assistant!</h3>
      <p>Ask AI can help answer your questions. Use any of the suggestions below or type your own in the text field below.</p>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
.chat-welcome-content{display:flex;flex:1;flex-direction:column;gap:24px;justify-content:flex-end;margin-bottom:48px;padding:20px 0}.chat-welcome{text-align:center}.chat-logo{align-items:center;background:linear-gradient(135deg,#6366f1,#8b5cf6);border-radius:50%;color:#fff;display:flex;font-size:24px;height:60px;justify-content:center;margin:0 auto 16px;width:60px}.chat-logo .iconify{background-color:#fff}.chat-welcome h3{color:#111827;font-size:20px;margin:0 0 12px}.chat-welcome p{color:#6b7280;line-height:1.5;margin:0}
</style>
